import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import AfterLoginNavbar from "components/Navbars/AfterLoginNavbar";
import Notification from "../../../services/Notification";
import {
  checkLogin,
  checkUserPermission,
  getUserActionPermission,
} from "../../../services/CheckUserAccess";

import swal from "sweetalert";
// Post Entry screen
import PostEntry from "./PostEntry";
import PostEntryAdd from "./AddPostEntry";
import PostEntryEdit from "./EditPostEntry";

const Index = (props) => {
  const classes = useStyles();
  const { path } = useRouteMatch();
  const menukey = "post-entry";

  const [RedirectLogin, setRedirectLogin] = React.useState(true);
  /*  const checkLogin = () => {  
    let token = sessionStorage.getItem("token");
    if (!token) {
      swal({
        title: "Oops!",
        text: 'token expired. Please login again',
        icon: "warning",
        buttons: ["No", "Yes"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) { 
          window.location.href = process.env.REACT_APP_BASE_NAME+`/login`;
          sessionStorage.clear();
        }
      });
    }
  }; */

  const [hasUserPermission, setHasUserPermission] = React.useState(false);

  if (RedirectLogin) {
    setHasUserPermission(checkUserPermission(menukey)); // To check user has permission in this page
    checkLogin();
    setRedirectLogin(false);
  }

  const permissionType = getUserActionPermission(menukey);

  React.useEffect(() => {
    // checkLogin();
    // checkAccess();
  }, []);

  const [msgObj, setMsgObj] = React.useState({
    isOpen: false,
  });
  const openNoticeModal = (obj) => {
    setMsgObj(obj);
  };
  const closeNoticeModal = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setMsgObj({ isOpen: false });
  };

  return (
    // <div>
    //   <AfterLoginNavbar {...props} />
    //   <div className={`section signup-top-padding ${classes.postentryContainer}`}>
    //     <Switch>
    //       <Route path={`${path}/add`} component={PostEntryAdd}></Route>
    //       <Route path={`${path}/edit/:id`} component={PostEntryEdit}></Route>
    //       <Route path={`${path}/`} component={PostEntry}></Route>
    //     </Switch>
    //   </div>
    // </div>

    (hasUserPermission && (<div>
      <AfterLoginNavbar {...props} />
      <div
        className={`section signup-top-padding ${classes.postentryContainer}`}
      >
        <Switch>
          <Route
            path={`${path}/add`}
            render={(props) => (
              <PostEntryAdd
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
          <Route
            path={`${path}/edit/:id`}
            render={(props) => (
              <PostEntryEdit
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
          <Route
            path={`${path}/`}
            render={(props) => (
              <PostEntry
                {...props}
                openNoticeModal={openNoticeModal}
                permissionType={permissionType}
              />
            )}
          ></Route>
        </Switch>
        <Notification
          closeNoticeModal={closeNoticeModal}
          msgObj={msgObj}
          {...props}
        ></Notification>
      </div>
    </div>))
  );
};

export default Index;

const useStyles = makeStyles({
  postentryContainer: {
    backgroundImage: "url(" + require("assets/img/bg8.jpg") + ")",
    backgroundSize: "cover",
    backgroundPosition: "top center",
    minHeight: "753px",
  },
});
